<template>
  <div style=" " class="headerContainer" :style="{ backgroundColor: transparent }">
    <div class="header">
      <div class="logo" @click="gohome" style="cursor: pointer;">
        <img class="logoImg" src="@/assets/logo.png" alt="">
      </div>
      <ul class="menuNav">
        <li class="menu-item" @click="handleSelect('1')" :style="{ color: activeIndex == '1' ? '#5893FF' : '' }">首页</li>
        <li class="menu-item">
          <span @click="handleSelect('2')" :style="{ color: activeIndex.includes('2') ? '#5893FF' : '' }">新闻中心</span>
          <ul class="submenu">
            <li @click="handleSelect('2-1')">企业动态</li>
            <li @click="handleSelect('2-2')">媒体报道</li>
            <li @click="handleSelect('2-3')">行业观察</li>
          </ul>
        </li>
        <li class="menu-item" @click="handleSelect('3')" :style="{ color: activeIndex == '3' ? '#5893FF' : '' }">关于我们</li>
        <li class="menu-item" @click="handleSelect('4')" :style="{ color: activeIndex == '4' ? '#5893FF' : '' }">远通天下慧运通</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1'
    }
  },
  props: ['transparent'],
  // watch:{
  //   $route(val){
  //     console.log(val);
  //         
  //   }
  // },
  mounted() {
    let val = this.$route.fullPath
    console.log(val);
    switch (val) {
      case '/':
        this.activeIndex = '1'
        break;
      case '/news':
        this.activeIndex = '2'
        break;
      case '/aboutus':
        this.activeIndex = '3'
        break;
      case '/newsInfo':
        this.activeIndex = '2'
        break;
      case '/news?index=1':
        this.activeIndex = '2-1'
        break;
      case '/news?index=2':
        this.activeIndex = '2-2'
        break;
      case '/news?index=3':
        this.activeIndex = '2-3'
        break;
    }
    if (this.$route.path == '/newsInfo') {
      this.activeIndex = '2'
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key
      switch (key) {
        case '1':
          this.$router.push({ name: "home" });
          break;
        case '2':
          this.$router.push({ name: "news" });
          break;
        case '3':
          this.$router.push({ name: "aboutus" });
          break;
        case '2-1':
          this.$router.push({ path: "news?index=1" });
          break;
        case '2-2':
          this.$router.push({ path: "news?index=2" });
          break;
        case '2-3':
          this.$router.push({ path: "news?index=3" });
          break;
          case '4':
          this.$router.push({ name: "aboutEN" });
          break;
      }
    },
    gohome() {
      if (this.$route.path == '/') {
     
          this.$parent.gotop()
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.headerContainer {
  width: 100%;
  background-color: transparent;

  &:hover {
    box-shadow: 0px 5px 9px 0px rgb(0 0 0 / 6%);
    background-color: #fff !important;
    opacity: 1 !important;
    transition: all .2s linear;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1300px;
  margin-left: 240px;
  padding-top: 20px;
  // margin-bottom: 30px;

  .logoImg {
    width: 162px;
    height: 38px;
  }

  .menuNav {
    display: flex;
    list-style: none;

    .menu-item {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
      position: relative;
      margin-right: 110px;
      padding: 10px 30px;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        color: #5893FF;

        .submenu {
          display: block;
          transform-origin: 50% 0;
          transition: all .2s;
        }
      }

      .submenu {
        list-style: none;
        position: absolute;
        left: 0;
        top: 50px;
        display: none;
        color: #333333;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0;

        li {
          cursor: pointer;
          padding: 10px 30px;

          &:hover {
            color: #5893FF;
          }
        }
      }
    }
  }

  .header-title {
    font-size: 20px !important;
    font-weight: bold !important;
  }

  :deep(.el-submenu__title) {
    font-size: 20px !important;
    font-weight: bold !important;
  }

  .el-menu-item {
    border: none;
    border-color: transparent !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    border-color: transparent !important;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none
  }
}
</style>